// extracted by mini-css-extract-plugin
module.exports = {"modal":"Gn","error":"Hn","disabled":"In","header":"Jn","footer":"Kn"};